import React, { useContext } from "react";
import { Grid, GridSize, Typography } from "@material-ui/core";
import FluentUiDatePicker from "../../Shared/FluentUiDatePicker";
import { SchoolContext } from "../../../contexts/SchoolContext";
import ClassroomsDropDown from "../../Shared/ClassroomsDropdown";
import { Checkbox, IDropdownOption, Slider, TextField } from "@fluentui/react";
import { useTranslation } from "react-i18next";

interface IProps {
  student: any;
  setStudent: (s: any) => void;
  disabled: boolean;
  md: GridSize;
  xs: GridSize;
  sm: GridSize;
}
export default function StudentPathForm({
  student,
  setStudent,
  disabled,
  md,
  xs,
  sm,
}: IProps) {
  const { t } = useTranslation();
  const { accademicYear } = useContext(SchoolContext);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="subtitle1">
          {t("studentPath.enrollmentYear", {
            start: accademicYear?.startDate?.getFullYear(),
            end: accademicYear?.endDate?.getFullYear(),
          })}
        </Typography>
      </Grid>
      <Grid item sm={sm} xs={xs} md={md}>
        <FluentUiDatePicker
          required
          label={t("services.startDate")}
          placeholder={t("services.startDate")}
          value={student.startDate}
          minDate={accademicYear?.startDate}
          maxDate={accademicYear?.endDate}
          onSelectDate={(date: Date | null | undefined): void => {
            setStudent({
              ...student,
              startDate: date,
            });
          }}
        />
      </Grid>
      <Grid item sm={sm} xs={xs} md={md}>
        <ClassroomsDropDown
          required
          label={t("studentPath.classroom")}
          placeholder={t("studentPath.selectClassroom")}
          selectedKey={student.classroomId}
          onChange={(
            event: React.FormEvent<HTMLDivElement>,
            item?: IDropdownOption
          ): void => {
            if (item)
              setStudent({
                ...student,
                classroomId: item.key,
              });
          }}
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <Slider
          label={t("studentPath.enrollmentFees")}
          max={accademicYear?.inscriptionFees ?? 2000}
          value={student.inscriptionFees ?? 0}
          defaultValue={student.inscriptionFees ?? 0}
          step={10}
          showValue
          onChange={(value: number) =>
            setStudent({
              ...student,
              inscriptionFees: value,
            })
          }
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <Slider
          label={t("studentPath.tuitionFees")}
          max={accademicYear?.monthlyFees ?? 2000}
          value={student.monthlyFees ?? 0}
          defaultValue={student.monthlyFees ?? 0}
          step={10}
          showValue
          onChange={(value: number) =>
            setStudent({
              ...student,
              monthlyFees: value,
            })
          }
        />
      </Grid>
      {accademicYear?.hasTransport &&
          <Grid item sm={6} md={4} xs={12}>
            <Checkbox
              label={t("studentPath.transport")}
              checked={student.hasTransport} onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) =>
                setStudent({ ...student, hasTransport: checked })}
            />
            <TextField
              required
              disabled={!student.hasTransport}
              label={t("studentPath.transportFees")}
              placeholder={t("studentPath.transportFeesPlaceholder")}
              value={student.transportFees ? student.transportFees?.toString() : accademicYear.transportFees?.toString()}
              type="number"
              lang="fr-FR"
              min="0"
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string
              ) => {
                if (!isNaN(Number(newValue))) {
                  let num: number = Number(newValue);
                  if (num < 0) num = num * -1;
                  setStudent({ ...student, transportFees: Number(num.toFixed(2)) })
                }
              }}
            />
          </Grid>
        }

        {accademicYear?.hasChildCare &&
          <Grid item sm={6} md={4} xs={12}>
            <Checkbox
              label={t("studentPath.childCare")}
              checked={student.hasChildCare} onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) =>
                setStudent({ ...student, hasChildCare: checked })}
            />
            <TextField
              required
              disabled={!student.hasChildCare}
              label={t("studentPath.childCareFees")}
              placeholder={t("studentPath.childCareFeesPlaceholder")}
              value={student.childCareFees ? student.childCareFees?.toString() : accademicYear.childCareFees?.toString()}
              type="number"
              lang="fr-FR"
              min="0"
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string
              ) => {
                if (!isNaN(Number(newValue))) {
                  let num: number = Number(newValue);
                  if (num < 0) num = num * -1;
                  setStudent({ ...student, childCareFees: Number(num.toFixed(2)) })
                }
              }}
            />
          </Grid>
        }

        {accademicYear?.hasCanteen &&
          <Grid item sm={6} md={4} xs={12}>
            <Checkbox
              label={t("studentPath.canteen")}
              checked={student.hasCanteen} onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) =>
                setStudent({ ...student, hasCanteen: checked })}
            />
            <TextField
              required
              disabled={!student.hasCanteen}
              label={t("studentPath.canteenFees")}
              placeholder={t("studentPath.canteenFeesPlaceholder")}
              value={student.canteenFees ? student.canteenFees?.toString() : accademicYear.canteenFees?.toString()}
              type="number"
              lang="fr-FR"
              min="0"
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string
              ) => {
                if (!isNaN(Number(newValue))) {
                  let num: number = Number(newValue);
                  if (num < 0) num = num * -1;
                  setStudent({ ...student, canteenFees: Number(num.toFixed(2)) })
                }
              }}
            />
          </Grid>
        }
    </Grid>
  );
}
